import dataLayerHelper from '../helpers/dataLayer';

const productItem = {
  initialize() {
    $('body').on('click', '.js-product-item a', (event) => {
      const element = event.currentTarget;

      this.trackProductClick(element);
    });
  },

  trackProductClick(element) {
    const product = JSON.parse(element.getAttribute('data-gtm-product'));

    dataLayerHelper.productClick(product);
  },
};

export default productItem;
